
import React, { useState } from 'react';
import { Button, Box, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { setState, exportTemplate_Data, ImportExcel } from "../scenarioSetupNewSlice";
import { useDispatch, useSelector } from "react-redux";

function BreakdownUpload() {
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.scenarioSetupNew);
  const {
    countryID, scenarioName, selectedCustsCGs, selectedCountry
  } = setupState;
  const handleFileUpload = (event) => {
    const fileObj = event.target.files[0];
    setUploadedFile(fileObj);
  };

  const handleDelete = () => {
    setUploadedFile(null);
  };
  const DownloadTemplate = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    else if (scenarioName === undefined || scenarioName === null || scenarioName === "") {
      showMessage("Please select a Scenario Name", "info");
      return;
    }
    else if (selectedCustsCGs <= 0) {
      showMessage("Please select a customer", "info");
      return;
    }
    else {
      let customersList = [];
      let customerGroupsList = [];
      for (let i = 0; i < selectedCustsCGs.length; i++) {
        if (selectedCustsCGs[i].type === "C") {
          let obj = {};
          obj['customerID'] = selectedCustsCGs[i].id;
          obj['customer'] = {};
          obj['customer']['customerName'] = selectedCustsCGs[i].name;
          customersList.push(obj);
        }
        else if (selectedCustsCGs[i].type === "CG" || selectedCustsCGs[i].type === "CT") {
          let obj = {};
          obj['customerGroupID'] = selectedCustsCGs[i].id;
          obj['customerGroup'] = {};
          obj['customerGroup']['customerGroupName'] = selectedCustsCGs[i].name;
          customerGroupsList.push(obj);
        }
        else if (selectedCustsCGs[i].hasOwnProperty("customerID")){
          let obj ={};
          obj['customerID'] = selectedCustsCGs[i].customerID;
          obj['customer'] = {};
          obj['customer']['customerName']= selectedCustsCGs[i].customerName;
          customersList.push(obj);
      }
      else if (selectedCustsCGs[i].hasOwnProperty("customerGroupID")){
          let obj ={};
          obj['customerGroupID'] = selectedCustsCGs[i].customerGroupID;
          obj['customerGroup'] = {};
          obj['customerGroup']['customerGroupName']= selectedCustsCGs[i].customerGroupName;
          customerGroupsList.push(obj);
      }
      }
      let obj = {
        scenarioId: 0,
        scenarioName: scenarioName, countryId: countryID,
        countryName: selectedCountry, customerGroup: customerGroupsList,
        customer: customersList
      }
      dispatch(exportTemplate_Data(obj));
    }
  }
  const UploadFile = () => {
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    else if (scenarioName === undefined || scenarioName === null || scenarioName === "") {
      showMessage("Please select a Scenario Name", "info");
      return;
    }
    else if (selectedCustsCGs <= 0) {
      showMessage("Please select a customer", "info");
      return;
    }
    else {
      dispatch(setState("scenarioExternalDataSource",[]));
      const formData = new FormData();
      formData.append("file", uploadedFile, uploadedFile.name);
      let recCnt = selectedCustsCGs.length;
      let obj = {
        scenario: scenarioName,
        recCnt: recCnt,
        formData: formData
      }
      dispatch(ImportExcel(obj));
      setUploadedFile(null);
    }
  }
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  return (
    <Box>
      <Box>
        <Grid container spacing={3} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <Grid item>
            <Box>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "grey.lighter",
                  color: "darkBlue.light",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkBlue.light",
                    color: "white.main",
                  },
                }}
                component="span"
                onClick={DownloadTemplate}
              >
                 TemplateDownload
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <input
                type="file"
                accept=".xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
                id="fileInput"
                onclick="fileInput.value = null"
                value=""
              />
              <label htmlFor="fileInput">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "grey.lighter",
                    color: "darkBlue.light",
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "darkBlue.light",
                      color: "white.main",
                    },
                  }}
                  component="span"
                >
                  Select File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              <Button
                variant="contained"
                disabled={uploadedFile==null || uploadedFile == undefined}
                sx={{
                  bgcolor: "grey.lighter",
                  color: "darkBlue.light",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkBlue.light",
                    color: "white.main",
                  },
                }}
                component="span"
                onClick={UploadFile}
              >
                Upload
              </Button>
            </Box>
          </Grid>

        </Grid>
      </Box>
      <Grid>
      {uploadedFile && (
        <Box sx={{mt: 1,borderBottom:0.25, borderColor: "#e0e0e0"}}>
            <div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <span>{uploadedFile.name}</span>
              {/* <Button variant="outlined" color="secondary" onClick={handleDelete}> */}
              {/* &nbsp;Delete  */}
              <DeleteIcon onClick={handleDelete} sx={{ cursor: "pointer"}}/>
              {/* </Button> */}
            </div> 
        </Box>
      )}
      </Grid>
    </Box>
  );
}

export default BreakdownUpload;
